<!--
 * @Description: 人员审核列表页面
 * @Author: gaohc, fengal
 * @Date: 2022-04-07 16:43:52
 * @LastEditTime: 2024-06-24 08:45:52
-->
<template>
  <div class="body">
    <el-row style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="8" style="text-align: left">
        <span class="search-title">机构名称：</span>
        <el-select size="small" style="width: 240px" v-model="filterParams.institutionId"
          clearable filterable placeholder="请输入/选择"
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList',
            srcInstitutionList, this))"
          @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
            'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList" :key="item.id" :label="item.name"
			      :value="item.id" />
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: center">
        <span class="search-title">审核状态：</span>
        <el-select size="small" style="width: 240px" v-model="filterParams.status" clearable
          filterable placeholder="请输入/选择">
          <el-option v-for="(item, index) in reviewStatusList" :key="index" :label="item.value"
            :value="item.key">
		      </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: right">
        <span class="search-title">人员信息：</span>
        <el-input size="small" style="width: 240px" placeholder="请输入姓名/手机号/身份证号"
          v-model="filterParams.nameOrMobileOrIdNo" clearable></el-input>
      </el-col>
    </el-row>

    <el-row style="margin: 0 40px 25px 40px" :gutter="0" type="flex" justify="space-between"
      align="middle">
      <el-col :span="8" style="text-align: left;display: flex;align-items: baseline;">
        <span class="search-title">审核类型：</span>
        <el-checkbox-group style="margin-left: 5px" v-model="checkReviewList">
          <el-checkbox label="10">注册信息</el-checkbox>
          <el-checkbox label="11">电子证书</el-checkbox>
          <el-checkbox v-if="false" label="">接单科室</el-checkbox>
        </el-checkbox-group>
        </el-col>
      <el-col :span="8" style="text-align: right">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search">
			    搜 索
		    </el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>

    <el-table style="margin: 25px 40px; border: 1px solid #f0f0f0" ref="table"
	    :default-sort="{ prop: 'date', order: 'descending' }" :style="tableWidth"
      :data="dataTable" header-cell-class-name="table-header-color" row-key="id">
      <el-table-column label="审核类型" min-width="10%" align="left">
        <template slot-scope="scope">
          {{ scope.row.typeText ? scope.row.typeText : '- -' }}
        </template>
      </el-table-column>
      <el-table-column label="姓名" min-width="10%" align="left">
        <template slot-scope="scope">
          <div style="display: flex; align-items: center;">
            <span>{{ scope.row.name ? scope.row.name : '- -' }}</span>
            <span v-if="scope.row.status == 0">
              <el-tag :type="scope.row.retrial == 0 ? 'danger' : ''" class="reviewTag" size="small">
                {{ scope.row.retrialText }}
              </el-tag>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="手机号" min-width="10%" align="left">
        <template slot-scope="scope">
          {{scope.row.mobile ? scope.row.mobile : "- -"}}
        </template>
      </el-table-column>
      <el-table-column label="机构名称" min-width="13%" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">
            {{scope.row.intitutionText ? scope.row.intitutionText : "- -"}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="性别" min-width="6%" align="left">
        <template slot-scope="scope">
          {{ scope.row.genderText ? scope.row.genderText : '- -'}}
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄" min-width="7%" align="left">
        <template slot-scope="scope">
          {{ scope.row.age ? scope.row.age + "岁" : '- -'}}
        </template>
      </el-table-column>
      <el-table-column prop="submitTimme" sortable label="提交时间" min-width="13%" align="left">
        <template slot-scope="scope">
          <span>{{scope.row.submitTimme ? rebuildDate(scope.row.submitTimme): "- -"}}</span>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" min-width="8%" align="left">
        <template slot-scope="scope">
          <!-- 0-待审核 1-已通过 2-已驳回 3-已撤回 -->
          <span v-if="!scope.row.reviewHistoryList.length"
            :style="{color: scope.row.status == '2' ? '#FF0909'
            : scope.row.status == '0' ? '#999999' : '#606266'}">
            {{ scope.row.statusText }}
          </span>
          <review-tooltip v-else :reviewStatus="scope.row.status"
            :statusText="scope.row.statusText" :data="scope.row.reviewHistoryList">
          </review-tooltip>
        </template>
      </el-table-column>
      <el-table-column sortable prop="reviewTime" label="审核时间" min-width="10%" align="left">
        <template slot-scope="scope">
          <span>
            {{scope.row.reviewTime ? rebuildDate(scope.row.reviewTime): "- -"}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="11%" align="left">
        <template slot-scope="scope">
          <el-button @click="handleDetailClick(scope.row)" type="text" size="small">
            详情
          </el-button>
          <template v-if="scope.row.status == 0">
            <el-divider direction="vertical"></el-divider>
            <el-button v-if="scope.row.status == 0 && dataPvgList.includes('ATDN_6_REVIEW')"
              @click="handleReviewed(scope.row)" type="text" size="small">
              审核
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber" />
    </el-row>

    <!-- 人员详情审核对话框 -->
    <attendant-review-details :visible="showReviewDialog" :reviewType="reviewType"
      :attendantId="attendantId" :isGlobalAdmin="isGlobalAdmin"
      @handle-review-attendant="handleAttendantReview"
      @handle-review-cert="handleCertReview"
      @close-dialog="closeSaveOrUpdateAttendantReviewDialog"/>

    <!-- 审核意见对话框 -->
    <review-comments-dialog :showReviewCommentsDialog="showReviewCommentsDialog"
      @handle-close-review-comments-dialog="handleCloseReviewCommentsDialog"
      :reviewStatus="reviewStatus" @handle-review-comments-msg="handleReviewCommentsMsg"/>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import AtdnOrCertReviewDetails from "./components/AtdnOrCertReviewDetails.vue";
import ReviewCommentsDialog from "./components/ReviewCommentsDialog.vue";
import ReviewTooltip from "./components/ReviewTooltip.vue";

export default {
  name: "AttendantReviewList",
  components: {
    "attendant-review-details": AtdnOrCertReviewDetails,
    "review-comments-dialog": ReviewCommentsDialog,
    "review-tooltip": ReviewTooltip,
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,
      checkReviewList: [],     //选择的审核类型
      institutionList: [],
      srcInstitutionList: [],
      levelMap: {},
      reviewStatusList: [],
      currentUserRole: "", //true-超级管理员或主管理员 false-一般管理员
      dataTable: [],
      attendantId: 0,
      // 通过或者驳回人员审核对象param
      attendantParams: {
        id: "",
        status: ""
      },

      //以下是对话框使用
      showReviewDialog: false,  //人员详情对话框是否显示变量
      showReviewCommentsDialog: false,  //审核意见对话框是否显示变量
      reviewStatus: "", //审核通过还是驳回标识
      isGlobalAdmin: null, //详情是否有审核权限标识
      reviewType: null  //人员审核还是证书审核标识
    };
  },

  computed: {
    tableWidth() {
      return "width:" + (this.$root.contentWidth - 80) + "px";
    },
  },
  methods: {
    async initData() {
      await this.getDataPvg4CurRole();
      await this.getFilterDo();
      await this.listAttendants();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'ATDN'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_ATTENTDANT_REVIEW_FILTER_DO).then((result) => {
          if (result == null) {
            return
          }

          this.initFilterData(result.data);
          //如果从机构跳转过来的携带机构ID，否则机构默认填充filter列表第一个
          if (this.$route.params.institutionId) {
            this.$set(this.filterParams, "institutionId", this.$route.params.institutionId);
          }
          resolve();
        })
      });
    },

    initFilterData(filterObj) {
      this.institutionList = filterObj.institutionList;
      this.srcInstitutionList = filterObj.institutionList;
      this.levelMap = filterObj.levelMap;
      this.reviewStatusList = this.commonUtil.map2List(filterObj.statusMap);
    },

    listAttendants() {
      return new Promise((resolve) => {
      
        if (this.filterParams.hasOwnProperty('typeList') && this.filterParams.typeList.length == 0) {
          delete this.filterParams.typeList;
        }
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_PAGE_ATTENTDANT_REVIEWS,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };

        this.vueRequest(requestData).then((result) => {
            if (result == null) {
              return;
            }
            this.dataTable = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          })
      });
    },

    handleQuery() {
      if(this.checkReviewList.length){
        this.filterParams.typeList = this.checkReviewList.join(",");
      }else {
        this.filterParams.typeList = [];
      }

      this.filterParams.page = 1;
      this.listAttendants();
    },

    //详情
    handleDetailClick(item) {
      this.attendantId = item.id;
      this.isGlobalAdmin = item.globalAdmin;
      this.reviewType = item.reviewType;
      this.attendantParams = {};
      this.showReviewDialog = true;
    },

    queryReviewStatusChange(reviewType) {
      let url = reviewType == 10 ? Constant.URL_UPDATE_ATTENTDANT_REVIEW_STATUS
        :Constant.URL_UPDATE_CERTIFICATE_REVIEW_STATUS;
      let header = this.encryptionUtil.signatureBody(this.attendantParams,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: url,
        param: this.attendantParams,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }
        this.listAttendants();
      });
    },

    //撤回
    handleWithdraw(item) {
      this.attendantParams.id = item.id;
      this.attendantParams.status = "canceled";
      this.attendantParams.version = item.version;
      this.$confirm(item.name + "的待审核申请将被撤回并删除，可在 机构管理-人员列表 中编辑保存后重新提交审核，是否继续?", "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      }).then(() => {
        this.queryReviewStatusChange(item.reviewType);
      });
    },

    //列表里审核操作触发
    handleReviewed(item) {
      this.attendantId = item.id;
      this.reviewType = item.reviewType;
      this.attendantParams.id = item.id;
      this.attendantParams.version = item.version;
      this.reviewStatus = "";
      this.showReviewCommentsDialog = true;
    },

    closeSaveOrUpdateAttendantReviewDialog(refresh) {
      this.showReviewDialog = false;
      if (refresh) this.listAttendants();
    },

    closeSaveOrUpdateAttendantDialog() {
      this.showAttendantDialog = false;
    },

    //关闭审核意见弹框
    handleCloseReviewCommentsDialog(item) {
      this.showReviewCommentsDialog = item;
    },

    //详情里面审核人员注册信息通过或者驳回操作触发
    handleAttendantReview(reviewStatus, version) {
      this.attendantParams.id = this.attendantId;
      this.attendantParams.version = version;
      this.reviewStatus = reviewStatus;
      this.showReviewCommentsDialog = true;
    },

    //详情里面证书审核通过或者驳回操作触发
    handleCertReview(certParam) {
      this.attendantParams = certParam;
      this.reviewStatus = certParam.status;
      this.showReviewCommentsDialog = true;
    },

    //审核意见框确定
    handleReviewCommentsMsg(comment, status) {
      this.attendantParams.comment = comment;
      this.attendantParams.status = status;
      this.queryReviewStatusChange(this.reviewType);
      this.showReviewCommentsDialog = false;
      this.showReviewDialog = false;
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listAttendants();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listAttendants();
    },

    rebuildDate(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    },
  },

  mounted() {
    this.$emit("breadcrumb", { text1: "审核管理", text2: "人员审核" });
    this.initData();
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
}

.main-line {
  height: 10px;
  background-color: #f2f3f4;
}

.foot-pagination {
  text-align: right;
  right: 40px;
  border: solid 0px;
}

.text-light-gray {
  color: #999999;
}

.text-red {
  color: #ff0909;
}

.el-tag {
  border-radius: 24px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/review/AttendantReviewList.vue